module.exports = __webpack_public_path__ + "static/media/browsers.932ca7d4.svg";